import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFolderOpen, faShoppingCart, faCogs, faChevronRight, faUser, faUserGraduate, faBookMedical, faClipboardCheck, faNetworkWired, faBoxes, faBriefcase, faCalendar ,faCashRegister} from '@fortawesome/free-solid-svg-icons'
import Api from "../servicios/api";

 class Menu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userProps: this.props,
      fullname: localStorage.getItem("k_nombre"),
      fotoperfil:''

    };
  }
  BuscarPaciente() {
    var cc = document.getElementById('searchx').value;
     if(cc==''){
      alert("Debes de digitar el numero de cedula");
      return false;
     }
    fetch(Api + "buscarpacientes/"+cc)
      .then(respuesta => respuesta.json())
      .then((datosRoles) => {
        console.log(datosRoles.id);
        if(datosRoles.id!=0){
          window.location.href = 'InfoPacientes/'+datosRoles.id;
        }else{
            alert(datosRoles.msj);
        }
        //this.setState({ roles: datosRoles })
      })
      .catch(console.log);
  }

  //const fullname = localStorage.getItem("k_nombre");
  render() {
    const {fullname } = this.state;
  return (
    <aside className="main-sidebar sidebar-light-primary elevation-4">
      {/* Brand Logo */}
      <Link to="/home" className="brand-link navbar-blue">
        <img src={process.env.PUBLIC_URL + '/dist/img/logo.png'} className="brand-image "  />
        
        <span className="brand-text font-weight-light text-white">Koala Calidad</span>
      </Link>
      {/* Sidebar */}
      <div className="sidebar">
        {/* Sidebar user panel (optional) */}
        <div className="user-panel mt-3 pb-3 mb-3 d-flex">
          <div className="image">
            <img src={process.env.PUBLIC_URL + '/dist/img/avatar3.png'} className="img-circle elevation-2" alt="User Image" />
          </div>
          <div className="info">
            <a href="#" className="d-block">{fullname}</a>
          </div>
        </div>
        {/* SidebarSearch Form */}
        <div className="form-inline">
          <div className="input-group">
            <input className="form-control form-control-sidebar" type="text" placeholder="Buscar por cedula"  id="searchx" />
            <div className="input-group-append">
              <button className="btn btn-sidebar text-white" onClick={this.BuscarPaciente}>
                <i className="fas fa-search text-black" />
              </button>
            </div>
          </div>
        </div>
        <div className="form-inline">
        
        </div>
        {/* Sidebar Menu */}
        <nav className="mt-2">
          <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
            {/* Add icons to the links using the .nav-icon class
         with font-awesome or any other icon font library */}
         
            <li className="nav-item menu-close">
              <a href="#" className="nav-link">
                <FontAwesomeIcon style={{ marginRight: 15 }} icon={faBookMedical} />
                <p>
                  Ordenes Internas
                  <i className="right fas fa-angle-left" />
                </p>
              </a>
              <ul className="nav nav-treeview">
               
                <li className="nav-item">
                  <Link to="/MasterOrdenes" className="nav-link">
                    <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                    <p>Lista de Ordenes</p>
                  </Link>
                </li>
              
              </ul>
            </li>
          
           
        
            <li className="nav-item menu-close">
              <a href="#" className="nav-link">
                <FontAwesomeIcon style={{ marginRight: 15 }} icon={faUser} />
                <p>
                  Pacientes
                  <i className="right fas fa-angle-left" />
                </p>
              </a>
              <ul className="nav nav-treeview">
                <li className="nav-item">
                  <Link to="/ListaPaciente" className="nav-link">
                    <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                    <p>Lista Pacientes</p>
                  </Link>
                </li>
               
              </ul>
            </li>
        
         
        
          
           
          </ul>
        </nav>
        {/* /.sidebar-menu */}
      </div>
      {/* /.sidebar */}
    </aside>
  );
   }
}
export default Menu;